<div  tabindex="-1">

    <div class="trx-details trx-detail-form">
      
        <ng-container>
            <!-- <box class="account-info">
                <span class="info-lbl">Merchant Id</span>
                <span class="info-val">{{ popupData.merchantId }}</span>
            </box> -->
            <box class="account-info">
              <span class="info-lbl">{{'Transaction Date : ' | translate}}</span>
              <span class="info-val">{{ popupData.transactionDate }}</span>
          </box>
             
        <box class="account-info">
            <span class="info-lbl">{{'Category : ' | translate}}</span>
            <span *ngIf="popupData.dbcrFlag == 'D'">
                <span class="info-val">Debit</span>
            </span>
              <span *ngIf="popupData.dbcrFlag == 'C'">
                <span class="info-val">Credit</span>
              </span>
        </box>



            <box class="account-info">
                <span class="info-lbl">{{'Debit Amount : ' | translate}}</span>
                <span class="info-val">{{ popupData.debitAmount }}</span>
            </box>
            
         
            <box class="account-info">
                <span class="info-lbl">{{'Narration : ' | translate}}</span>
                <span class="info-val">{{ popupData.narration }}</span>
            </box>

        </ng-container>
        
        
    </div>
</div>